import React, { useEffect, useState, useMemo } from "react";
import {
  convertFromHTML,
  convertFromRaw,
  EditorState,
  ContentState,
} from "draft-js";

import { Editor } from "@tinymce/tinymce-react";
import { toast } from "react-toastify";
import draftToHtml from "draftjs-to-html";

import isURL from "validator/lib/isURL";
import { useDispatch, useSelector } from "react-redux";
import { updateAutomationSettings } from "../../../redux/actions/automationSettings";
import UTCtime from "./UTCtime";
import TextEditor from "./TextEditor";
import { getGroupSettings } from "../../../redux/actions/groupSettings";
import AutoApproveForm from "./AutoApproveForm";

const content = {
  entityMap: {},
  blocks: [
    {
      key: "637gr",
      text: "",
      type: "unstyled",
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
};

const initialFormForAutomationPost = {
  group: "",
  automationType: "welcome",
  contentText: "",
  contentHtml: "",
  content: content,
  postUrl: "",
  postTitle: "",
  ageOfMember: 0,
  scheduleType: "",
  timeScheduleValue: "",
  sendMessage: {
    value: false,
    delayTime: "",
    // messageGroup: "",
  },
};

const AutomationPostForm = ({
  setOpenForm,
  groups,
  groupFilter,
  currentAutomationForUpdate,
  curautomationId,
  setCurautomationId,
  openForm,
  messageGroups,
}) => {
  const [automationPostForm, setAutomationPostForm] = useState(
    groupFilter
      ? { ...initialFormForAutomationPost, group: groupFilter }
      : initialFormForAutomationPost
  );

  const [selectedGroupFbId, setSelectedGroupFbId] = useState(
    groupFilter
      ? groups.find((group) => group._id === groupFilter)?.groupId
      : ""
  );

  const [textEdtState, setTextEdtState] = useState({
    editorState: EditorState.createEmpty(),
  });

  const [selectedGroup, setSelectedGroup] = useState(null);

  const groupsettings = useSelector((state) => state.groupSettings);
  const { groupSetting } = groupsettings;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  // console.log("userInfo", userInfo)
  // for auto set delay time on group select
  useEffect(() => {
    // console.log("working", groupSetting)
    if (groupSetting?.operationProcedure?.delayTime) {
      setAutomationPostForm({
        ...automationPostForm,
        sendMessage: {
          ...automationPostForm.sendMessage,
          delayTime: groupSetting?.operationProcedure?.delayTime || "",
        },
      });
    } else {
      setAutomationPostForm({
        ...automationPostForm,
        sendMessage: { ...automationPostForm.sendMessage, delayTime: "" },
      });
    }
  }, [groupSetting]);

  // console.log("groups", groups)
  useEffect(() => {
    // console.log("currentAutomationForUpdate", curautomationId, currentAutomationForUpdate)
    if (curautomationId && currentAutomationForUpdate) {
      typeof currentAutomationForUpdate?.group === "string"
        ? setAutomationPostForm({
            ...currentAutomationForUpdate,
            group: currentAutomationForUpdate?.group,
            sendMessage: {
              ...currentAutomationForUpdate?.sendMessage,
              messageGroup:
                typeof currentAutomationForUpdate?.sendMessage?.messageGroup ===
                "string"
                  ? currentAutomationForUpdate?.sendMessage?.messageGroup
                  : currentAutomationForUpdate?.sendMessage?.messageGroup?._id,
            },
          })
        : setAutomationPostForm({
            ...currentAutomationForUpdate,
            group: currentAutomationForUpdate?.group?._id,
            sendMessage: {
              ...currentAutomationForUpdate?.sendMessage,
              messageGroup:
                typeof currentAutomationForUpdate?.sendMessage?.messageGroup ===
                "string"
                  ? currentAutomationForUpdate?.sendMessage?.messageGroup
                  : currentAutomationForUpdate?.sendMessage?.messageGroup?._id,
            },
          });

      setSelectedGroupFbId(currentAutomationForUpdate?.group?.groupId);
      setTextEdtState({
        editorState: EditorState.createWithContent(
          ContentState.createFromBlockArray(
            convertFromHTML(currentAutomationForUpdate?.contentHtml)
          )
        ),
      });
      const group = groups.find(
        (group) => group._id === currentAutomationForUpdate?.group?._id
      );
      setSelectedGroup(group || null);
    }
  }, [curautomationId, currentAutomationForUpdate]);

  useEffect(() => {
    const inline_tool = document.querySelectorAll(
      'div[aria-label="rdw-inline-control"]'
    );
    if (automationPostForm.automationType === "comment") {
      inline_tool[0].style.display = "none";
    } else if (automationPostForm.automationType === "welcome") {
      inline_tool[0].removeAttribute("style");
    }
  }, [automationPostForm.automationType]);

  useEffect(() => {
    if (groupFilter) {
      // dispatch(getGroupSettings(groupFilter));
      const group = groups.find((group) => group._id === groupFilter);
      setSelectedGroup(group || null);
    }
  }, [groupFilter]);

  useEffect(() => {
    if (groupFilter && !curautomationId) {
      dispatch(getGroupSettings(groupFilter));
    }
  }, [groupFilter, curautomationId]);

  const titlePlaceholderText = useMemo(() => {
    let text = "Enter post title";
    if (automationPostForm.automationType === "sendMessage") {
      text = "Enter message title";
    } else if (automationPostForm.automationType === "autoApprove") {
      text = "Enter title";
    }
    return text;
  }, [automationPostForm.automationType]);

  // console.log("automationPostForm", automationPostForm)

  /** Re format text for text editor */
  var charArray = [];
  charArray["A"] = ["𝗔", "𝘈", "𝘼", "A̶", "𝒜"];
  charArray["B"] = ["𝗕", "𝘉", "𝘽", "B̶", "ℬ"];
  charArray["C"] = ["𝗖", "𝘊", "𝘾", "C̶", "𝒞"];
  charArray["D"] = ["𝗗", "𝘋", "𝘿", "D̶", "𝒟"];
  charArray["E"] = ["𝗘", "𝘌", "𝙀", "E̶", "ℰ"];
  charArray["F"] = ["𝗙", "𝘍", "𝙁", "F̶", "ℱ"];
  charArray["G"] = ["𝗚", "𝘎", "𝙂", "G̶", "𝒢"];
  charArray["H"] = ["𝗛", "𝘏", "𝙃", "H̶", "ℋ"];
  charArray["I"] = ["𝗜", "𝘐", "𝙄", "I̶", "ℐ"];
  charArray["J"] = ["𝗝", "𝘑", "𝙅", "J̶", "𝒥"];
  charArray["K"] = ["𝗞", "𝘒", "𝙆", "K̶", "𝒦"];
  charArray["L"] = ["𝗟", "𝘓", "𝙇", "L̶", "ℒ"];
  charArray["M"] = ["𝗠", "𝘔", "𝙈", "M̶", "ℳ"];
  charArray["N"] = ["𝗡", "𝘕", "𝙉", "N̶", "𝒩"];
  charArray["O"] = ["𝗢", "𝘖", "𝙊", "O̶", "𝒪"];
  charArray["P"] = ["𝗣", "𝘗", "𝙋", "P̶", "𝒫"];
  charArray["Q"] = ["𝗤", "𝘘", "𝙌", "Q̶", "𝒬"];
  charArray["R"] = ["𝗥", "𝘙", "𝙍", "R̶", "ℛ"];
  charArray["S"] = ["𝗦", "𝘚", "𝙎", "S̶", "𝒮"];
  charArray["T"] = ["𝗧", "𝘛", "𝙏", "T̶", "𝒯"];
  charArray["U"] = ["𝗨", "𝘜", "𝙐", "U̶", "𝒰"];
  charArray["V"] = ["𝗩", "𝘝", "𝙑", "V̶", "𝒱"];
  charArray["W"] = ["𝗪", "𝘞", "𝙒", "W̶", "𝒲"];
  charArray["X"] = ["𝗫", "𝘟", "𝙓", "X̶", "𝒳"];
  charArray["Y"] = ["𝗬", "𝘠", "𝙔", "Y̶", "𝒴"];
  charArray["Z"] = ["𝗭", "𝘡", "𝙕", "Z̶", "𝒵"];
  charArray["a"] = ["𝗮", "𝘢", "𝙖", "a̶", "𝒶"];
  charArray["b"] = ["𝗯", "𝘣", "𝙗", "b̶", "𝒷"];
  charArray["c"] = ["𝗰", "𝘤", "𝙘", "c̶", "𝒸"];
  charArray["d"] = ["𝗱", "𝘥", "𝙙", "d̶", "𝒹"];
  charArray["e"] = ["𝗲", "𝘦", "𝙚", "e̶", "ℯ"];
  charArray["f"] = ["𝗳", "𝘧", "𝙛", "f̶", "𝒻"];
  charArray["g"] = ["𝗴", "𝘨", "𝙜", "g̶", "ℊ"];
  charArray["h"] = ["𝗵", "𝘩", "𝙝", "h̶", "𝒽"];
  charArray["i"] = ["𝗶", "𝘪", "𝙞", "i̶", "𝒾"];
  charArray["j"] = ["𝗷", "𝘫", "𝙟", "j̶", "𝒿"];
  charArray["k"] = ["𝗸", "𝘬", "𝙠", "k̶", "𝓀"];
  charArray["l"] = ["𝗹", "𝘭", "𝙡", "l̶", "𝓁"];
  charArray["m"] = ["𝗺", "𝘮", "𝙢", "m̶", "𝓂"];
  charArray["n"] = ["𝗻", "𝘯", "𝙣", "n̶", "𝓃"];
  charArray["o"] = ["𝗼", "𝘰", "𝙤", "o̶", "ℴ"];
  charArray["p"] = ["𝗽", "𝘱", "𝙥", "p̶", "𝓅"];
  charArray["q"] = ["𝗾", "𝘲", "𝙦", "q̶", "𝓆"];
  charArray["r"] = ["𝗿", "𝘳", "𝙧", "r̶", "𝓇"];
  charArray["s"] = ["𝘀", "𝘴", "𝙨", "s̶", "𝓈"];
  charArray["t"] = ["𝘁", "𝘵", "𝙩", "t̶", "𝓉"];
  charArray["u"] = ["𝘂", "𝘶", "𝙪", "u̶", "𝓊"];
  charArray["v"] = ["𝘃", "𝘷", "𝙫", "v̶", "𝓋"];
  charArray["w"] = ["𝘄", "𝘸", "𝙬", "w̶", "𝓌"];
  charArray["x"] = ["𝘅", "𝘹", "𝙭", "x̶", "𝓍"];
  charArray["y"] = ["𝘆", "𝘺", "𝙮", "y̶", "𝓎"];
  charArray["z"] = ["𝘇", "𝘻", "𝙯", "z̶", "𝓕"];
  charArray["1"] = ["𝟭", "1", "𝟭", "1̶", "1"];
  charArray["2"] = ["𝟮", "2", "𝟮", "2̶", "2"];
  charArray["3"] = ["𝟯", "3", "𝟯", "3̶", "3"];
  charArray["4"] = ["𝟰", "4", "𝟰", "4̶", "4"];
  charArray["5"] = ["𝟱", "5", "𝟱", "5̶", "5"];
  charArray["6"] = ["𝟲", "6", "𝟲", "6̶", "6"];
  charArray["7"] = ["𝟳", "7", "𝟳", "7̶", "7"];
  charArray["8"] = ["𝟴", "8", "𝟴", "8̶", "8"];
  charArray["9"] = ["𝟵", "9", "𝟵", "9̶", "9"];
  charArray["0"] = ["𝟬", "0", "𝟬", "0̶", "0"];

  const reformatIt = (theText, textType) => {
    var c = "";
    var reformatted = "";
    for (var x = 0; x < theText.length; x++) {
      c = theText.charAt(x);
      if (c in charArray) {
        reformatted += charArray[c][textType];
      } else {
        reformatted += c;
      }
    }
    return reformatted;
  };

  /** handle text editor output value */
  const handleEditorChange = (content) => {
    console.log(content);
    setAutomationPostForm({
      ...automationPostForm,
      // contentHtml: editor.getContent({ format: 'html' }),
      // contentText: editor.getContent({ format: 'text' }),
      contentText: draftToHtml(content)
        .replace(/<\/?.+?>/gi, "")
        .replace(/&nbsp;/g, ""),
      contentHtml: draftToHtml(content),
      content: content,
    });
  };

  /** Validate Form before submit */
  const validatePostAutomationForm = () => {
    const delayTime = automationPostForm?.sendMessage?.delayTime;
    if (
      automationPostForm.scheduleType === "repeat" &&
      (parseInt(automationPostForm.timeScheduleValue) <= 0 ||
        !automationPostForm.timeScheduleValue)
    ) {
      return {
        pass: false,
        errorMsg: "Provide a valid input for time schedule",
      };
    } else if (
      automationPostForm.scheduleType === "repeat" &&
      !Number.isInteger(parseFloat(automationPostForm.timeScheduleValue))
    ) {
      return {
        pass: false,
        errorMsg: "You can't use decimal vales for Time schedule.",
      };
    }

    if (
      parseInt(automationPostForm.ageOfMember) < 0 ||
      automationPostForm.ageOfMember === ""
    ) {
      return {
        pass: false,
        errorMsg: "Provide a valid input for age in group",
      };
    } else if (!Number.isInteger(parseFloat(automationPostForm.ageOfMember))) {
      return {
        pass: false,
        errorMsg: "You can't use decimal vales for Age in group.",
      };
    }

    if (!automationPostForm.postTitle.trim()) {
      return {
        pass: false,
        errorMsg:
          "Title is required!",
      };
    }
    if (!automationPostForm.group) {
      return {
        pass: false,
        errorMsg:
          "Please select the group!",
      };
    }
    if (automationPostForm.automationType === "welcome") {
      if (
        !automationPostForm.group ||
        !automationPostForm.contentHtml ||
        !automationPostForm.contentText ||
        !automationPostForm.postTitle ||
        !automationPostForm.scheduleType ||
        !automationPostForm.timeScheduleValue
      ) {
        return {
          pass: false,
          errorMsg:
            "Please fill all required fields with valid input to create a welcome post automation!",
        };
      }
      if (automationPostForm.sendMessage?.value === true) {
        if (!automationPostForm.sendMessage?.messageGroup) {
          return {
            pass: false,
            errorMsg: "Provide select message group or disable send message.",
          };
        } else if (!delayTime || isNaN(delayTime) || Number(delayTime) < 0) {
          return {
            pass: false,
            errorMsg: "Provide enter delay time or disable send message.",
          };
        } else if (!Number.isInteger(parseFloat(delayTime))) {
          return {
            pass: false,
            errorMsg: "You can't use decimal vales for delay time.",
          };
        }
      }
      return {
        pass: true,
        errorMsg: "",
      };
    } else if (automationPostForm.automationType === "comment") {
      if (
        !automationPostForm.group ||
        !automationPostForm.contentHtml ||
        !automationPostForm.contentText ||
        !automationPostForm.postTitle ||
        !automationPostForm.postUrl ||
        !automationPostForm.scheduleType ||
        !automationPostForm.timeScheduleValue
      ) {
        return {
          pass: false,
          errorMsg:
            "Please fill all required fields with valid input to create a comment post automation!",
        };
      }

      if (!isURL(automationPostForm.postUrl)) {
        return {
          pass: false,
          errorMsg: "Please give a valid Post URL!",
        };
      }

      if (automationPostForm.sendMessage?.value === true) {
        if (!automationPostForm.sendMessage?.messageGroup) {
          return {
            pass: false,
            errorMsg: "Provide select message group or disable send message.",
          };
        } else if (!delayTime || isNaN(delayTime) || Number(delayTime) < 0) {
          return {
            pass: false,
            errorMsg: "Provide enter delay time or disable send message.",
          };
        } else if (!Number.isInteger(parseFloat(delayTime))) {
          return {
            pass: false,
            errorMsg: "You can't use decimal vales for delay time.",
          };
        }
      }
      // let postUrlArr = automationPostForm.postUrl.split('/');

      // if (postUrlArr[postUrlArr.indexOf('groups') + 1] !== selectedGroupFbId) {
      // 	return {
      // 		pass: false,
      // 		errorMsg: 'Post URL is not valid for this group !',
      // 	};
      // }

      return {
        pass: true,
        errorMsg: "",
      };
    } else if (automationPostForm.automationType === "sendMessage") {
      if (automationPostForm.sendMessage?.value !== true) {
        return {
          pass: false,
          errorMsg: "Provide enable message group.",
        };
      }
      if (!automationPostForm.sendMessage?.messageGroup) {
        return {
          pass: false,
          errorMsg: "Provide select message group.",
        };
      } else if (!delayTime || isNaN(delayTime) || Number(delayTime) < 0) {
        return {
          pass: false,
          errorMsg: "Provide enter delay time.",
        };
      } else if (!Number.isInteger(parseFloat(delayTime))) {
        return {
          pass: false,
          errorMsg: "You can't use decimal vales for delay time.",
        };
      }

      return {
        pass: true,
        errorMsg: "",
      };
    } else if (automationPostForm.automationType === "autoApprove") {
      const groupSettings = automationPostForm.groupSettings;
      if (
        groupSettings.preApproveSheetOpen &&
        (!groupSettings.operationProcedure.preApproveSheet ||
          !groupSettings.operationProcedure.emailQuestionForPreApproved)
      ) {
        toast.info(
          "If you unable to give email question input then please save your group memebership questions from facebook member request page and reload this page !"
        );
        return {
          pass: false,
          errorMsg: "Please provide pre-approve sheet and email question!",
        };
      }

      if (
        groupSettings.invalidEmailAction &&
        (!groupSettings.operationProcedure.verifyEmail ||
          !groupSettings.operationProcedure.emailQuestion)
      ) {
        toast.info(
          "If you unable to give email question input then please save your group memebership questions from facebook member request page and reload this page !"
        );
        return {
          pass: false,
          errorMsg:
            "Please provide action for invalid email and email question!",
        };
      }
      const delayTimeAutoApprove = groupSettings.operationProcedure?.delayTime;
      if (
        groupSettings.operationProcedure?.sendMessageIfReqAccept?.value ||
        groupSettings.operationProcedure?.sendMessageForQuestion?.value ||
        groupSettings.operationProcedure?.autoDecline?.value
      ) {
        // console.log(
        //   "delayTimeAutoApprove",
        //   delayTimeAutoApprove,
        //   isNaN(delayTimeAutoApprove)
        // );
        if (
          !delayTimeAutoApprove ||
          isNaN(delayTimeAutoApprove) ||
          Number(delayTimeAutoApprove) < 0
        ) {
          return {
            pass: false,
            errorMsg: "Please enter default delay time for messaging!",
          };
        } else if (!Number.isInteger(parseFloat(delayTimeAutoApprove))) {
          return {
            pass: false,
            errorMsg: "You can't use decimal vales for delay time. ",
          };
        }
      }

      if (
        groupSettings?.operationProcedure?.sendMessageIfReqAccept?.value &&
        !groupSettings?.operationProcedure?.sendMessageIfReqAccept.messageGroup
      ) {
        return {
          pass: false,
          errorMsg:
            "Please select a message group for send message if join request is accepted!",
        };
      }
      // if (
      //   groupSettings?.operationProcedure?.autoDecline?.value &&
      //   !groupSettings?.operationProcedure?.autoDecline.messageGroup
      // ) {
      //   return {
      //     pass: false,
      //     errorMsg: "Please select a message group for auto decline!",
      //   };
      // }
      if (
        groupSettings?.operationProcedure?.sendMessageForQuestion?.value &&
        (!groupSettings?.operationProcedure?.sendMessageForQuestion
          .messageGroup ||
          !groupSettings?.operationProcedure?.sendMessageForQuestion.question ||
          !groupSettings?.operationProcedure?.sendMessageForQuestion.answer)
      ) {
        return {
          pass: false,
          errorMsg:
            "Please fill complete details for Send message only for specific question!",
        };
      }

      if (
        groupSettings.webhookExportOption &&
        !groupSettings.exportOption.webhook
      ) {
        return {
          pass: false,
          errorMsg: "Please provide webhook to export your data!",
        };
      }
      if (
        groupSettings.googleSheetExportOption &&
        !groupSettings.exportOption.exportSheet
      ) {
        return {
          pass: false,
          errorMsg: "Please provide spreadsheet to export your data!",
        };
      }
      if (
        groupSettings.operationProcedure?.autoDecline?.value &&
        !groupSettings.operationProcedure?.ifAllAnswered &&
        !groupSettings.preApproveSheetOpen &&
        !groupSettings.invalidEmailAction
      ) {
        return {
          pass: false,
          errorMsg: `Please select at least one of these three options for auto-decline! \n 1.Only approve if answered all questions. \n
        2.Only approve if pre-approved. \n 3.Verify email address.`,
        };
      }
      if (
        !groupSettings.exportOption.webhook &&
        !groupSettings.exportOption.exportSheet &&
        !groupSettings.exportOption.csvDownload
      ) {
        return {
          pass: false,
          errorMsg: "Please select atleast one export option!",
        };
      }
      return {
        pass: true,
        errorMsg: "",
      };
    } else {
      return {
        pass: false,
        errorMsg: "Please provide a valid automation type!",
      };
    }
  };

  // console.log("groupSettings", automationPostForm.groupSettings);

  const dispatch = useDispatch();
  // console.log("automationPostForm", automationPostForm)
  /** handle Form submission */
  const submitHandler = (e) => {
    e.preventDefault();
    let returnedValidationOutput =
      validatePostAutomationForm(automationPostForm);
    // console.log("returnedValidationOutput", returnedValidationOutput)
    if (returnedValidationOutput.pass) {
      // submit the form
      let formData = automationPostForm;
      // console.log("formData", formData);
      if (
        automationPostForm.groupSettings &&
        automationPostForm.automationType === "autoApprove"
      ) {
        formData = {
          ...automationPostForm,
          groupSettings: {
            exportOption: automationPostForm.groupSettings.exportOption,
            operationProcedure:
              automationPostForm.groupSettings.operationProcedure,
          },
        };
      } else {
        const updatedFormData = formData;
        delete updatedFormData.groupSettings;
        formData = updatedFormData;
      }
      if (!automationPostForm?.sendMessage?.messageGroup) {
        formData = {
          ...formData,
          sendMessage: {
            value: automationPostForm?.sendMessage?.value,
            delayTime: automationPostForm?.sendMessage?.delayTime,
          },
        };
      }
      // console.log("formData updated", formData);

      if (curautomationId) {
        dispatch(updateAutomationSettings(formData, curautomationId));
      } else {
        dispatch(updateAutomationSettings(formData));
      }
      // setAutomationPostForm(initialFormForAutomationPost);

      return true;
    } else {
      toast.error(returnedValidationOutput.errorMsg);
      return false;
    }
  };

  return (
    <div
      className="modalDivWraper Create customizedModal automatioFormOuterWraper activated"
      style={{
        width:
          automationPostForm.automationType === "autoApprove"
            ? "800px"
            : "auto",
      }}
    >
      <div className="modalHeaderWraper">
        <h4 className="modalHeading">Create Automation</h4>
      </div>
      <div className="innerModalWraper automatioFormInnerWraper">
        <div
          className="fieldWrapers modalFields textCenter"
          style={{ paddingRight: 25 }}
        >
          <div className="individualExpots">
            <span className="checkOptions">
              <p>Select Group</p>
            </span>
            <span className="dropdownOptions">
              <div className="selectWraper automation">
                <select
                  value={automationPostForm.group}
                  onChange={(e) => {
                    setAutomationPostForm({
                      ...automationPostForm,
                      group: e.target.value,
                    });
                    setSelectedGroupFbId(
                      e.target.selectedOptions[0].getAttribute("data-groupid")
                    );
                    if (e.target.value) {
                      dispatch(getGroupSettings(e.target.value));
                      const group = groups.find(
                        (group) => group._id === e.target.value
                      );
                      setSelectedGroup(group || null);
                    }
                  }}
                >
                  <option value="">Select a group</option>
                  {groups &&
                    groups.length &&
                    groups.map((group) => {
                      return (
                        <option
                          value={group._id}
                          key={group.groupId}
                          data-groupid={group.groupId}
                        >
                          {group.groupName}
                        </option>
                      );
                    })}
                </select>
              </div>
            </span>
          </div>

          <div className="individualExpots">
            <span className="checkOptions">
              <p>Automation type</p>
            </span>
            <span className="dropdownOptions">
              <div className="selectWraper automation">
                <select
                  onChange={(e) => {
                    if (e.target.value === "comment") {
                      setAutomationPostForm({
                        ...automationPostForm,
                        automationType: e.target.value,
                      });
                    } else if (
                      e.target.value === "sendMessage" ||
                      e.target.value === "autoApprove"
                    ) {
                      if (userInfo.planNo < 5) {
                        toast.info(
                          "Please upgrade your account to use messaging feature!"
                        );
                      } else {
                        const values = {
                          ...automationPostForm,
                          automationType: e.target.value,
                          postUrl: "",
                        };
                        if (e.target.value === "sendMessage") {
                          values.sendMessage = {
                            ...automationPostForm.sendMessage,
                            value: true,
                          };
                        }
                        setAutomationPostForm(values);
                      }
                    } else {
                      setAutomationPostForm({
                        ...automationPostForm,
                        automationType: e.target.value,
                        postUrl: "",
                      });
                    }
                  }}
                  value={automationPostForm.automationType}
                >
                  <option value="welcome">Welcome Post</option>
                  <option value="comment">Comment Post</option>
                  <option value="sendMessage">Send Message</option>
                  <option value="autoApprove">Auto Approve</option>
                </select>
              </div>
            </span>
          </div>

          <div className="individualExpots">
            <span className="checkOptions">
              <p>
                {automationPostForm.automationType === "sendMessage" ||
                automationPostForm.automationType === "autoApprove"
                  ? "Title"
                  : "Post title"}
              </p>
            </span>
            <span className="dropdownOptions">
              <div className="selectWraper automation">
                <input
                  type="text"
                  className="inputBox"
                  placeholder={titlePlaceholderText}
                  style={{ marginBottom: "0px" }}
                  onChange={(e) =>
                    setAutomationPostForm({
                      ...automationPostForm,
                      postTitle: e.target.value,
                    })
                  }
                  value={automationPostForm.postTitle}
                />
              </div>
            </span>
          </div>
          {automationPostForm.automationType === "comment" ? (
            <div className="individualExpots">
              <span className="checkOptions">
                <p>Post url</p>
              </span>
              <span className="dropdownOptions">
                <div className="selectWraper automation">
                  <input
                    type="text"
                    className="inputBox"
                    placeholder="Enter your post url"
                    onChange={(e) =>
                      setAutomationPostForm({
                        ...automationPostForm,
                        postUrl: e.target.value,
                      })
                    }
                    value={automationPostForm.postUrl}
                  />
                </div>
              </span>
            </div>
          ) : (
            ""
          )}
          {automationPostForm.automationType === "autoApprove" ? (
            ""
          ) : (
            <>
              <div className="individualExpots send-message-automation-wrapper">
                <span className="checkOptions">
                  <p>Send Message</p>
                </span>
                <div className="flex">
                  <span className=" switch">
                    <label
                      className="switchAuto"
                      style={{
                        marginTop: "12px",
                      }}
                    >
                      <input
                        type="checkbox"
                        disabled={
                          automationPostForm?.automationType === "sendMessage"
                        }
                        checked={automationPostForm?.sendMessage?.value}
                        // disabled={!automation.validPlan ? true : false}
                        onChange={(e) => {
                          if (userInfo.planNo < 5) {
                            toast.info(
                              "Please upgrade your account to use messaging feature!"
                            );
                          } else {
                            setAutomationPostForm({
                              ...automationPostForm,
                              sendMessage: {
                                ...automationPostForm.sendMessage,
                                value: automationPostForm?.sendMessage?.value
                                  ? false
                                  : true,
                              },
                            });
                          }
                        }}
                      />
                      <span className="sliderAuto round"></span>
                    </label>
                  </span>
                  <span className="dropdownOptions">
                    <div className="selectWraper automation">
                      <select
                        disabled={
                          automationPostForm?.sendMessage?.value === false
                        }
                        onChange={(e) => {
                          setAutomationPostForm({
                            ...automationPostForm,
                            sendMessage: {
                              ...automationPostForm.sendMessage,
                              messageGroup: e.target.value,
                            },
                          });
                        }}
                        value={automationPostForm?.sendMessage?.messageGroup}
                      >
                        <option value="">Select Message Group</option>
                        {messageGroups?.map((messageGroup) => {
                          return (
                            <option
                              key={messageGroup._id}
                              value={messageGroup._id}
                            >
                              {messageGroup.title}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </span>
                  <span className="dropdownOptions" style={{ width: "43%" }}>
                    <div className="selectWraper automation" style={{display: "flex"}}>
                      <input
                        disabled={
                          automationPostForm?.sendMessage?.value === false
                        }
                        type="number"
                        className="inputBox"
                        min="0"
                        placeholder="Delay time"
                        style={{ marginBottom: "0px" }}
                        onChange={(e) =>
                          setAutomationPostForm({
                            ...automationPostForm,
                            sendMessage: {
                              ...automationPostForm.sendMessage,
                              delayTime: e.target.value,
                            },
                          })
                        }
                        defaultValue={
                          groupSetting?.operationProcedure?.delayTime
                        }
                        value={automationPostForm?.sendMessage?.delayTime}
                      />
                      <span className="addons" style={{padding: "12px 9px", marginLeft: "-5px"}}>Sec</span>
                    </div>
                  </span>
                </div>
              </div>
              <p
                style={{
                  fontSize: "12px",
                  color: "rgba(155, 174, 188, 1)",
                  marginTop: "8px",
                  marginBottom: "15px",
                  textAlign: "left",
                }}
              >
                ** Note: By default there will be a 60 seconds random delay
              </p>
              {automationPostForm.automationType !== "sendMessage" && (
                <>
                  <div className="individualExpots texteditors">
                    <span className="checkOptions">
                      <p>{`${
                        automationPostForm.automationType === "comment"
                          ? "Comment content"
                          : "Post content"
                      }`}</p>
                    </span>
                    <span className="dropdownOptions"></span>
                  </div>
                  <p
                    style={{
                      fontSize: "12px",
                      color: "rgba(155, 174, 188, 1)",
                      marginTop: "8px",
                      marginBottom: "15px",
                      textAlign: "left",
                      lineHeight: 1.75,
                    }}
                  >
                    *Note: To use SPINTAX in your content please follow this
                    structure.
                    <br />
                    {`{Hello|Hi}, hope you're doing {good|fine|awesome}`}
                  </p>
                  <div className="individualExpots texteditors">
                    <div className="fieldWrapers">
                      <TextEditor
                        handleEditorChange={handleEditorChange}
                        automationPostForm={automationPostForm}
                        textEdtState={textEdtState}
                        setTextEdtState={setTextEdtState}
                        // editorState={EditorState.createWithContent(
                        // 	ContentState.createFromBlockArray(
                        // 		convertFromHTML(automationPostForm.contentHtml)
                        // 			.contentBlocks,
                        // 		convertFromHTML(automationPostForm.contentHtml).entityMap
                        // 	)
                        // )}
                      />
                      {/* <Editor
                  // value={htmlContent}
                  value={automationPostForm.contentHtml}
                  init={{
                    height: 150,
                    menubar: false,
                    width: '100%',
                    background: '#F5F5F5',
                    plugins: [
                      'emoticons advlist lists image charmap print preview',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount',
                    ],
                    toolbar: `emoticons undo redo | bold italic strikethrough`,
                    entity_encoding: 'raw',
                    force_p_newlines: false,
                    force_br_newlines: false,
                    convert_newlines_to_brs: false,
                    remove_linebreaks: false,
                    fix_table_elements: false,
                    remove_redundant_brs: false,
                    validate_children: false,
                    forced_root_block: false,
                    cleanup: false,
                    cleanup_on_startup: false,
                    verify_html: false,
                    relative_urls: false,
                    init_instance_callback: (editor) => {
                      editor.contentDocument.body.style.backgroundColor =
                        '#F5F5F5';
                      editor.on('ExecCommand', function (e) {
                        var textType;
                        var theText = editor.selection.getContent({
                          format: 'text',
                        });
                        if (
                          e.command === 'mceToggleFormat' &&
                          e.value === 'bold'
                        ) {
                          editor.focus();
                          textType = 0;
                          editor.selection.setContent(
                            reformatIt(theText, textType)
                          );
                          editor.undoManager.add();
                        }
                        if (
                          e.command === 'mceToggleFormat' &&
                          e.value === 'italic'
                        ) {
                          editor.focus();
                          textType = 1;
                          editor.selection.setContent(
                            reformatIt(theText, textType)
                          );
                          editor.undoManager.add();
                        }
                        if (
                          e.command === 'mceToggleFormat' &&
                          e.value === 'strikethrough'
                        ) {
                          editor.focus();
                          textType = 3;
                          editor.selection.setContent(
                            reformatIt(theText, textType)
                          );
                          editor.undoManager.add();
                        }
                      });
                    },
                  }}
                  onEditorChange={handleEditorChange}
                /> */}
                      {/* <textarea
                  className='textAreaDummy'
                  placeholder='This is a dummy textarea which shall be replaced by an editor by the developer very very soon.'
                  onChange={(e) =>
                    setAutomationPostForm({
                      ...automationPostForm,
                      content: e.target.value,
                    })
                  }
                ></textarea> */}
                    </div>
                  </div>
                </>
              )}

              <div className="individualExpots">
                <span className="checkOptions">
                  <p>Age in group</p>
                </span>
                <span className="dropdownOptions">
                  <div className="selectWraper automation">
                    <input
                      type="number"
                      min="0"
                      className="inputBox withAddons"
                      style={{
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                      }}
                      placeholder="0"
                      onChange={(e) =>
                        setAutomationPostForm({
                          ...automationPostForm,
                          ageOfMember: e.target.value,
                        })
                      }
                      value={automationPostForm.ageOfMember}
                    />
                    <span className="addons">Days</span>
                  </div>
                </span>
              </div>
            </>
          )}

          <div className="individualExpots withAddon">
            <span className="checkOptions">
              <p>Time Schedule</p>
            </span>
            <span className="dropdownOptions">
              <div className="individualExpots subSorts">
                <span className="checkOptions">
                  <label className="checkBoxText automationCheckboxText">
                    Every
                    <input
                      type="radio"
                      name="scheuleType"
                      value="repeat"
                      onChange={(e) =>
                        setAutomationPostForm({
                          ...automationPostForm,
                          scheduleType: e.target.value,
                          timeScheduleValue: "",
                        })
                      }
                      checked={
                        automationPostForm.scheduleType === "repeat"
                          ? true
                          : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                </span>
                <span className="dropdownOptions">
                  <div className="selectWraper automation">
                    <input
                      type="number"
                      className="inputBox withAddons"
                      style={{
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                      }}
                      placeholder="E.g. 5"
                      min="0"
                      disabled={
                        automationPostForm.scheduleType === "repeat"
                          ? false
                          : true
                      }
                      onChange={(e) =>
                        setAutomationPostForm({
                          ...automationPostForm,
                          timeScheduleValue: e.target.value,
                        })
                      }
                      value={automationPostForm.timeScheduleValue}
                    />
                    <span className="addons">Hours</span>
                  </div>
                </span>
              </div>
            </span>
          </div>

          <div className="individualExpots withAddon">
            <span className="checkOptions">
              <p></p>
            </span>
            <span className="dropdownOptions">
              <div className="individualExpots sublongs">
                <span className="checkOptions">
                  <label className="checkBoxText automationCheckboxText">
                    Once per day <br /> (UTC Time)
                    <input
                      type="radio"
                      name="scheuleType"
                      value="once"
                      onChange={(e) => {
                        setAutomationPostForm({
                          ...automationPostForm,
                          scheduleType: e.target.value,
                          timeScheduleValue: "",
                        });
                      }}
                      checked={
                        automationPostForm.scheduleType === "once"
                          ? true
                          : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                </span>
                <span className="dropdownOptions">
                  <div className="selectWraper automation">
                    <input
                      type="time"
                      className="inputBox withAddons"
                      style={{ width: "100%", textAlign: "center" }}
                      disabled={
                        automationPostForm.scheduleType === "once"
                          ? false
                          : true
                      }
                      onChange={(e) =>
                        setAutomationPostForm({
                          ...automationPostForm,
                          timeScheduleValue: e.target.value,
                        })
                      }
                      value={automationPostForm.timeScheduleValue}
                    />
                    {/* <span className='addons selects selectWraper automation'>
											<select>
												<option value='1'>AM</option>
												<option value='2'>PM</option>
											</select>
										</span> */}
                  </div>
                </span>
                {automationPostForm.automationType === "autoApprove" ? (
                  ""
                ) : (
                  <p className="smallSubInfo has-text-yellow">
                    * You can tag maximum 50 people in a post <br />* Automation
                    will take maximum 5 minutes to run
                  </p>
                )}
                {openForm && <UTCtime />}
              </div>
            </span>
          </div>

          {automationPostForm.automationType === "autoApprove" ? (
            <AutoApproveForm
              groupSetting={groupSetting}
              selectedAutomation={currentAutomationForUpdate}
              userInfo={userInfo}
              groupDetails={selectedGroup}
              onChange={(groupSettings) => {
                // console.log("groupSettings", groupSettings)
                setAutomationPostForm({
                  ...automationPostForm,
                  groupSettings: groupSettings,
                });
              }}
            />
          ) : (
            ""
          )}

          <div
            className="buttonWraper customizeWraper"
            style={{ padding: "0" }}
          >
            <button className="confirmBtn" onClick={submitHandler}>
              Save
            </button>
            <button
              className="cancelBtn creates"
              onClick={() => {
                setOpenForm((val) => false);
                setCurautomationId("");
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutomationPostForm;
